<template>
	<div class="n-presence" :title="title">
		<span class="n-presence__dot" :class="{ 'is-on': connected }" />
		<div v-if="users.length" class="n-presence__stack">
			<n-avatar v-for="(u, i) in shown" :key="u.id" size="sm" :src="u.image_url" :name="u.username" :style="{ marginLeft: i ? '-8px' : '0', zIndex: 10 - i }" />
			<span v-if="overflow > 0" class="n-presence__more">+{{ overflow }}</span>
		</div>
		<span v-else class="n-presence__empty">{{ connected ? 'sin nadie más en línea' : 'desconectado' }}</span>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import NAvatar from './NAvatar';

const store = useStore();

const props = defineProps({
	max: { type: Number, default: 5 },
});

const connected = computed(() => store.getters['socket/connected']);
const online = computed(() => store.getters['socket/usersOnline'] || {});
const users = computed(() => Object.values(online.value));
const shown = computed(() => users.value.slice(0, props.max));
const overflow = computed(() => Math.max(0, users.value.length - props.max));
const title = computed(() => (users.value.length ? `${users.value.length} en línea` : 'presencia'));
</script>

<style scoped>
.n-presence { display: inline-flex; align-items: center; gap: var(--n-s2); }
.n-presence__dot { width: 8px; height: 8px; border-radius: 50%; background: var(--n-muted); }
.n-presence__dot.is-on { background: var(--n-success); box-shadow: 0 0 0 3px rgba(23, 201, 100, 0.18); }
.n-presence__stack { display: inline-flex; align-items: center; }
.n-presence__more {
	margin-left: -8px;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: var(--n-primary-050);
	color: var(--n-primary);
	font-size: 10px;
	font-weight: 700;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 0 2px #fff;
}
.n-presence__empty { font-size: var(--n-fs-xs); color: var(--n-muted); }
</style>
